import { Zone, ZoneType } from '../../types'

interface useResolveZoneReturnType {
  getSortedZoning: (defaultZoning: Zone[]) => Zone[]
  getZoneById: (zoning: Zone[], zoneId: string) => Zone | undefined
  resolveZone: (
    zoning: Zone[],
    zoneId?: string,
  ) => {
    zone?: Zone
    floor?: Zone
    building?: Zone
  }
}

export const useResolveZone = (): useResolveZoneReturnType => {
  const getSortedZoning = (defaultZoning: Zone[]): Zone[] => {
    const zoning: Zone[] = []
    const sortedBuildings = [...defaultZoning].sort((a, b) => a.index - b.index)

    for (const building of sortedBuildings) {
      zoning.push(building)
      const sortedFloors = [...building.children].sort((a, b) => a.index - b.index)

      for (const floor of sortedFloors) {
        zoning.push(floor)
        const sortedZones = [...floor.children].sort((a, b) => a.index - b.index)
        zoning.push(...sortedZones)
      }
    }

    return zoning
  }

  const resolveZone = (
    zoning: Zone[],
    zoneId?: string,
  ): {
    zone?: Zone
    floor?: Zone
    building?: Zone
  } => {
    if (!zoneId) {
      return {
        zone: undefined,
        floor: undefined,
        building: undefined,
      }
    }

    const taskZone = getZoneById(zoning, zoneId)
    const zone = taskZone && taskZone.type == ZoneType.Zone ? taskZone : undefined
    const floor =
      taskZone && taskZone.type == ZoneType.Floor
        ? taskZone
        : zone?.parentId
        ? getZoneById(zoning, zone.parentId)
        : undefined
    const building =
      taskZone && taskZone.type == ZoneType.Building
        ? taskZone
        : floor?.parentId
        ? getZoneById(zoning, floor.parentId)
        : undefined

    return {
      zone,
      floor,
      building,
    }
  }

  const getZoneById = (zoning: Zone[], zoneId: string): Zone | undefined => {
    for (const building of zoning) {
      if (building.id == zoneId) {
        return building
      }

      for (const floor of building.children) {
        if (floor.id == zoneId) {
          return floor
        }

        for (const zone of floor.children) {
          if (zone.id == zoneId) {
            return zone
          }
        }
      }
    }

    return undefined
  }

  return { resolveZone, getSortedZoning, getZoneById }
}
